import { PageHeader } from "@/pages/Categories";
import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";

const PHASES = [
  {
    n: "01",
    title: "Discovery & Brief",
    items: ["Product specification & target market", "Quantity, target price & timeline", "Required certifications & compliance", "Sample / reference materials"],
  },
  {
    n: "02",
    title: "Supplier Sourcing",
    items: ["Match against our vetted network", "Identify net-new manufacturers as needed", "Initial capability & capacity check", "Shortlist 3–6 candidates"],
  },
  {
    n: "03",
    title: "Verification",
    items: ["Document verification (GST, IEC, audits)", "Factory checks coordinated case by case", "Reference & track-record validation", "Compliance fit against your category"],
  },
  {
    n: "04",
    title: "Sample & Validation",
    items: ["Sample requests & courier", "Lab test coordination (where relevant)", "Feedback loops & revisions", "Pilot run option"],
  },
  {
    n: "05",
    title: "Commercial Negotiation",
    items: ["Pricing, MOQs and tooling", "Payment terms & milestones", "Incoterms & lead-time commitments", "Tooling / NRE charges"],
  },
  {
    n: "06",
    title: "Production & QC",
    items: ["Production tracking", "In-line / pre-shipment QC coordination", "Documentation prep (COA, SDS, etc.)", "Final approval gate"],
  },
  {
    n: "07",
    title: "Export & Delivery",
    items: ["Freight forwarder coordination", "Export paperwork & customs", "FCL / LCL planning", "Shipment tracking through delivery"],
  },
  {
    n: "08",
    title: "Account Management",
    items: ["Repeat orders & supplier reviews", "Continuous improvement", "Quality & price benchmarking", "New project pipeline"],
  },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-page">
      <PageHeader
        eyebrow="HOW IT WORKS"
        title="The VYR Trade sourcing pipeline."
        sub="A repeatable, document-first process used across every category — from first brief to repeat orders."
      />
      <section className="max-w-7xl mx-auto px-6 lg:px-8 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {PHASES.map((p) => (
            <div key={p.n} className="relative border border-white/5 bg-zinc-900/40 rounded-lg p-6" data-testid={`how-${p.n}`}>
              <div className="flex items-center gap-3 mb-4">
                <div className="font-mono text-amber-400 tnum text-sm">{p.n}</div>
                <div className="h-px flex-1 bg-white/5" />
                <div className="h-1.5 w-1.5 rounded-full bg-blue-500" />
              </div>
              <div className="font-display text-xl font-semibold">{p.title}</div>
              <ul className="mt-4 space-y-2">
                {p.items.map((it) => (
                  <li key={it} className="flex items-start gap-2 text-[13.5px] text-zinc-300">
                    <ArrowRight className="h-3.5 w-3.5 text-zinc-500 mt-[3px] shrink-0" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link to="/quote" className="inline-flex items-center gap-2 px-5 py-3 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm font-medium" data-testid="how-cta-quote">
            Start your sourcing brief <ArrowUpRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
